import script from "./DefaultTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultTable.vue?vue&type=script&setup=true&lang=js"

import "./DefaultTable.vue?vue&type=style&index=0&id=355a1472&lang=css"

const __exports__ = script;

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTd});
